import { Alternative, ALL_ALTERNATIVES } from "src/helpers/types";
import AlternativesCarouselCard from "./AlternativesCarouselCard";
import TravelTimeExplanation from "./TravelTimeExplanation";
import ExampleTripMap from "./ExampleTripMap";
import { TypographyH3, TypographyP } from "../Typography";
import { TypographyH2 } from "../Typography";
import { useContext } from "react";
import { LanguageContext } from "../languageContext";
import { HeaderIds } from "src/helpers/uiConstants";
import LazyScroll from "./LazyScroll";
import { isMobile } from "src/helpers/mapConstants";

export default function CirculationChanges() {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="space-y-4">
      <TypographyH2
        id={HeaderIds.circulationHeader}
        textId="changeVehicleCirculation"
      />
      <div className="space-y-20">
        <div>
          <TypographyP textId="alternativeChanges" />
          <ul className="mt-6 list-disc ml-6">
            <li className="mb-4">
              <strong>{translate("altName-NB_Only")}</strong>
              <br />
              {translate("circulationChanges-NB_Only")}
            </li>
            <li className="mb-4">
              <strong>{translate("altName-SB_Only")}</strong>
              <br />
              {translate("circulationChanges-SB_Only")}
            </li>
            <li className="mb-4">
              <strong>{translate("altName-Converging_Diverging")}</strong>
              <br />
              {translate("circulationChanges-Converging_Diverging")}
            </li>
            <li className="mb-4">
              <strong>{translate("altName-Converging_Diverging_Short")}</strong>
              <br />
              {translate("circulationChanges-Converging_Diverging_Short")}
            </li>
          </ul>
        </div>
        <div className="space-y-4">
          <TypographyH2
            className="mb-8"
            id={HeaderIds.exampleTripsHeader}
            textId="exampleTrips"
          />
          <TypographyP textId="exampleTripsDescription" />
          <TypographyH3 textId="theMuniDropoff" />
          <LazyScroll height={isMobile ? "200px" : "400px"}>
            <img
              className="w-full"
              src={`${process.env.PUBLIC_URL}/exampleTrip1Illustration.png`}
              alt={translate("exampleTrip1IllustrationAlt")}
            />
          </LazyScroll>
          <TypographyP textId="theMuniDropoffDescription" />
          <TypographyP textId="theMuniDropoffDescription2" />
          <div className="flex justify-center">
            <LazyScroll height={isMobile ? "632px" : "724px"}>
              <AlternativesCarouselCard
                alternatives={ALL_ALTERNATIVES}
                map={(alternative) => (
                  <ExampleTripMap
                    alternative={alternative}
                    endMarkerClassName="top-[65px] md:top-[60px] ml-[35px]"
                    startMarkerClassName="bottom-[93px] md:bottom-[92px] mr-[10px]"
                    tripId="exampleTrip1"
                  />
                )}
              >
                {(alternative) => {
                  const altToTime: Record<
                    Alternative,
                    { minutes: number; seconds: number }
                  > = {
                    existing: { minutes: 5, seconds: 59 },
                    NB_Only: { minutes: 6, seconds: 2 },
                    SB_Only: { minutes: 6, seconds: 21 },
                    Converging_Diverging: { minutes: 6, seconds: 1 },
                    Converging_Diverging_Short: { minutes: 5, seconds: 39 },
                  };
                  return (
                    <TravelTimeExplanation
                      alternative={alternative}
                      hours={0}
                      stringKey="exampleTrip1"
                      {...altToTime[alternative]}
                    />
                  );
                }}
              </AlternativesCarouselCard>
            </LazyScroll>
          </div>
        </div>
        <div className="space-y-4">
          <TypographyH3 textId="crossbayCommute" />
          <LazyScroll height={isMobile ? "200px" : "400px"}>
            <img
              className="w-full"
              src={`${process.env.PUBLIC_URL}/exampleTrip2Illustration.png`}
              alt={translate("exampleTrip2IllustrationAlt")}
            />
          </LazyScroll>
          <TypographyP textId="crossbayCommuteDescription" />
          <TypographyP textId="crossbayCommuteDescription2" />
          <div className="flex justify-center">
            <LazyScroll height={isMobile ? "632px" : "724px"}>
              <AlternativesCarouselCard
                alternatives={ALL_ALTERNATIVES}
                map={(alternative) => (
                  <ExampleTripMap
                    alternative={alternative}
                    endMarkerClassName="bottom-[82px] ml-[37px]"
                    startMarkerClassName="top-[30px]"
                    tripId="exampleTrip2"
                  />
                )}
              >
                {(alternative) => {
                  const altToTime: Record<
                    Alternative,
                    { minutes: number; seconds: number }
                  > = {
                    existing: { minutes: 5, seconds: 39 },
                    NB_Only: { minutes: 6, seconds: 24 },
                    SB_Only: { minutes: 5, seconds: 53 },
                    Converging_Diverging: { minutes: 7, seconds: 3 },
                    Converging_Diverging_Short: { minutes: 6, seconds: 20 },
                  };
                  return (
                    <TravelTimeExplanation
                      alternative={alternative}
                      hours={0}
                      stringKey="exampleTrip2"
                      {...altToTime[alternative]}
                    />
                  );
                }}
              </AlternativesCarouselCard>
            </LazyScroll>
          </div>
        </div>
      </div>
    </div>
  );
}
